import axios from 'axios';

// Use environment variable for backend URL, fallback to current origin
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || window.location.origin) || (typeof window !== 'undefined' ? window.location.origin : '');
const API_URL = `${BACKEND_URL}/api`;

// Check if online
export const isOnline = () => {
  return navigator.onLine;
};

// Check internet connection before data operations
export const checkInternetConnection = () => {
  if (!navigator.onLine) {
    throw new Error('NO_INTERNET');
  }
  return true;
};

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add timezone offset header for data entry operations
    // This helps verify the user is in UAE
    const timezoneOffset = new Date().getTimezoneOffset();
    config.headers['X-Timezone-Offset'] = timezoneOffset.toString();
    
    // Check internet connection for POST/PUT/DELETE operations (data entry)
    if (['post', 'put', 'delete'].includes(config.method?.toLowerCase())) {
      if (!navigator.onLine) {
        return Promise.reject({
          response: {
            status: 0,
            data: {
              detail: 'لا يوجد اتصال بالإنترنت. الإدراج لن يُحفظ. يرجى تسجيل الخروج، التأكد من الاتصال بالإنترنت، ثم تسجيل الدخول مجدداً.'
            }
          },
          isNetworkError: true
        });
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle network errors
    if (!error.response && !navigator.onLine) {
      error.response = {
        status: 0,
        data: {
          detail: 'لا يوجد اتصال بالإنترنت. الإدراج لن يُحفظ. يرجى تسجيل الخروج، التأكد من الاتصال بالإنترنت، ثم تسجيل الدخول مجدداً.'
        }
      };
      error.isNetworkError = true;
    }
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Track page visit (for analytics)
export const trackVisit = async (page = '/') => {
  try {
    await axios.post(`${API_URL}/public/track-visit`, { page });
  } catch (error) {
    // Silently fail - don't block user experience
    console.log('Visit tracking skipped');
  }
};

export default api;